import '../css/index.less'
import laypage from './laypage'
var index = {
  WIDTH: 0,
  HEIGHT: 0,
  CSSURL: '/asset/collegeleague2021-school/index/css/',
  options: {},
  isOpen: true,
  Init: function () {
    const that = this
    this.GeamSwitch() //切换游戏主题
    this.Events() //事件流

    //初始化学校列表
    $.ajax({
      url: '/collegeleague/school',
      success: function (res) {
        window.schoolData2020 = res.data
      },
    })

    //解说介绍点击报名
    $('#btn_signUp').on('click', function () {
      that.BoxModel(true, {
        eml: '.btn-recru',
        eml_act: '#model_error',
        off_value: 800,
      })
      that.XClose('#model_error')
      $('#error-info').html('').html('敬请期待~')
    })
  },
  InitItems(v, swit) {
    this.Theme(v) //游戏主题
    this.NewsItems(v) //赛事新闻
    if (!online) this.ImageLoad(v, swit) //赛事集锦
    this.Videos(v) //视频集锦
    this.OnlineTeam(v) //在线组队
    this.EventRules(v) //赛事规则
    this.wxshare(v) //微信分享
  },
  authProcess() {
    //报名认v证和报名流程
    const self = this
    const auth_data = {
      auth: {
        title: '如何完成学生认证',
        dota2: [
          {
            img:
              'https://img.dota2.com.cn/file/12/ab/12abf35f2302dfd26126b87be87ab0161597911720.png',
            title: '1.登陆完美电竞APP',
          },
          {
            img:
              'https://img.dota2.com.cn/file/7e/b7/7eb7521f6aa0c379ab956feccd78f37d1597911566.png',
            title: '2.进入个人信息页',
          },
          {
            img:
              'https://img.dota2.com.cn/file/88/06/880625f34be2d6e6e3e7f9051c2516101597911584.png',
            title: '3.提交认证信息',
          },
          {
            img:
              'https://img.dota2.com.cn/file/65/37/6537515ac3c76700c2c7cb5f5a51964f1597911601.png',
            title: '4.审核成功',
          },
        ],
        csgo: [
          {
            img:
              'https://img.dota2.com.cn/file/66/0e/660ef4815b12b0d5d41bd1fc064624d71597911417.png',
            title: '1.登陆完美电竞APP',
          },
          {
            img:
              'https://img.dota2.com.cn/file/7e/b7/7eb7521f6aa0c379ab956feccd78f37d1597911566.png',
            title: '2.进入个人信息页',
          },
          {
            img:
              'https://img.dota2.com.cn/file/88/06/880625f34be2d6e6e3e7f9051c2516101597911584.png',
            title: '3.提交认证信息',
          },
          {
            img:
              'https://img.dota2.com.cn/file/65/37/6537515ac3c76700c2c7cb5f5a51964f1597911601.png',
            title: '4.审核成功',
          },
        ],
      },
      auth2: {
        title: '如何报名比赛',
        dota2: [
          {
            img:
              'https://img.dota2.com.cn/file/d0/50/d05046cdc62f99dba8ad10183897fb001597922436.png',
            title: '1.选择要报名的比赛',
          },
          {
            img:
              'https://img.dota2.com.cn/file/47/56/47569491de196885cd9e0b9d6a879a101597922446.png',
            title: '2.开始报名',
          },
          {
            img:
              'https://img.dota2.com.cn/file/4b/46/4b464ddc932568f24960474fa31b5d1b1597922460.png',
            title: '3.提交参赛选手名单',
          },
          {
            img:
              'https://img.dota2.com.cn/file/18/f9/18f9bc8aa9c7c7979020ea568757dc3d1597922472.png',
            title: '4.等待比赛开始',
          },
        ],
        csgo: [
          {
            img:
              'https://img.dota2.com.cn/file/86/50/865003020a5435bcee3bb6a6dbf824501586320832.png',
            title: '1.赛事中心',
          },
          {
            img:
              'https://img.dota2.com.cn/file/29/19/291986e9c4860cbdbbdc0dcd6fa094e41586320844.png',
            title: '2.报名比赛',
          },
          {
            img:
              'https://img.dota2.com.cn/file/91/54/915443376badc7586d3dbff00fc769201586320854.png',
            title: '3.完成报名',
          },
        ],
      },
    }
    let j_btn_auth = $('.j_btn_auth')
    j_btn_auth.click(function () {
      let type = $(this).data('type')
      let theme = self.getCookie('gameName')

      self.BoxModel(true, {
        eml_act: '#model_auth',
        off_value: 942,
      })
      let TPL = new Pwrd_Template()
      let J_auth_temp = $('#j-auth-temp')
      let J_auth = $('#j-auth')
      let temp = TPL.template(J_auth_temp.html())
      J_auth.html(
        temp({
          title: auth_data[type].title,
          data: auth_data[type][theme],
        })
      )
      $('.slick-sec3').on('init', function () {
        J_auth.find('li')
          .eq(0)
          .addClass('active')
          .siblings()
          .removeClass('active')
      })
      $('.slick-sec3').slick({
        arrows: false, //启用Tab键和箭头键导航
        infinite: true, //无限循环滑动
        autoplay: true, //开启自动播放
      })
      $('.slick-sec3').on(
        'beforeChange',
        function (event, slick, currentSlide, nextSlide) {
          J_auth.find('li')
            .eq(nextSlide)
            .addClass('active')
            .siblings()
            .removeClass('active')
        }
      )
      self.XClose('#model_auth')
    })

    let J_auth = $('#j-auth')
    J_auth.on('click', 'li', function () {
      const self = $(this)
      let _index = self.index()
      $('.slick-sec3').slick('slickGoTo', _index, false)
    })
  },
  GeamSwitch() {
    const that = this
    let btnTheme = document.querySelectorAll('.entry-btns button')
    let v = 'dota2'
    //初始化主题
    if (that.getCookie('gameName') == '') {
      that.InitItems(v, 'init')
      that.setCookie('gameName', v, 360)
    } else {
      v = that.getCookie('gameName')
      that.InitItems(v, 'init')
    }
    $('body').attr('id', 'page_' + that.getCookie('gameName'))
    //切换主题
    for (let i = 0; i < btnTheme.length; i++) {
      btnTheme[i].addEventListener('click', themeTab, false)
    }
    function themeTab(e) {
      v = e.target.getAttribute('data-theme')
      if (v === that.getCookie('gameName')) return false
      switch (v) {
        case 'dota2':
          that.InitItems(v, 'swit')
          that.setCookie('gameName', v, 360)
          break
        case 'csgo':
          that.InitItems(v, 'swit')
          that.setCookie('gameName', v, 360)
      }
      $('body').attr('id', 'page_' + that.getCookie('gameName'))
    }
  },
  Theme(v) {
    const that = this
    let $theme = document.getElementById('theme')
    let $themeUrl = that.CSSURL + v + '_theme.css?v=' + new Date().getTime()
    $theme === null ? createStyle($themeUrl) : ($theme.href = $themeUrl)
    function createStyle(href) {
      let nodeStyle = document.createElement('link')
      nodeStyle.href = href
      nodeStyle.rel = 'stylesheet'
      nodeStyle.type = 'text/css'
      nodeStyle.id = 'theme'
      document.querySelector('head').appendChild(nodeStyle)
    }

    //title
    document.querySelector('title').innerHTML =
      '完美世界全国高校联赛-' + (v === 'csgo' ? 'CS:GO' : 'DOTA2')
  },
  NewsItems(v) {
    let that = this
    let newUrl =
      v === 'dota2' ? 'https://www.dota2.com.cn' : 'https://www.csgo.com.cn'
    $.ajax({
      url: newUrl + '/news/listbytag?t=' + encodeURI('2021高校赛春季赛'),
      dataType: 'jsonp',
      success: function (data) {
        laypage({
          cont: 'pagination_box',
          pages: data.total_pages,
          last: data.total_pages,
          prev: ' ',
          next: ' ',
          first: false,
          jump: function (obj) {
            $.ajax({
              url:
                newUrl + '/news/listbytag?t=' + encodeURI('2021高校赛春季赛'),
              dataType: 'jsonp',
              data: {
                page: obj.curr,
              },
              success: function (data) {
                that.pages = data.current_page
                that.UpdateNews(data.data)
              },
            })
          },
        })
      },
      error: function (err) {
        console.log(err)
      },
    })
  },
  ImageLoad(v, swit) {
    const that = this
    let J_slick_img = $('#J_slick_img')
    if (swit === 'swit') $('.slick-sec1').slick('unslick')
    $.ajax({
      url: '/collegeleague2019?task=getmedia&all=1&game=' + v,
      dataType: 'json',
      success: function (data) {
        var data = data.data
        for (var i = 0, str = ''; i < data.length; i++) {
          str +=
            '<div class="img-box">' +
            '<img data-title="' +
            data[i].title +
            '" src="" data-thumb="' +
            data[i].thumb +
            '" data-url="' +
            data[i].images.join(',') +
            '">' +
            '<p>' +
            data[i].title +
            '</p>' +
            '</div>'
        }
        J_slick_img.html('').html(str)
        $('.slick-sec1').slick({
          rows: 2,
          infinite: false, //是否循环播放
          //slidesToShow:3, //幻灯片每屏显示个数
          //slidesToScroll:3, //幻灯片每次滑动个数
          slidesPerRow: 4,
          // rtl: true,
        })

        loadImags(J_slick_img)
        $('.slick-sec1').on(
          'afterChange',
          function (event, slick, currentSlide, nextSlide) {
            loadImags(J_slick_img)
          }
        )
        that.WonderImgs()
      },
      error: function (err) {
        console.log(err)
      },
    })
    function loadImags(eml) {
      var _img = eml.find('.slick-active').find('img')
      for (var i = 0; i < _img.length; i++) {
        _img.eq(i).attr('src', _img.eq(i).data('thumb'))
      }
    }
  },
  WonderImgs() {
    const that = this
    let imgs = $('.slick-sec1 .img-box img')
    let J_items_imgs = $('#J_items_img')
    let J_thum_img = $('#J_thum_img')
    imgs.click((e) => {
      let me = $(e.target)
      let imtUrls = me.data('url').split(',')
      let strImg = ''
      let thumImg = ''
      for (let i = 0; i < imtUrls.length; i++) {
        strImg +=
          '<div>' +
          '<p class="tit">' +
          me.data('title') +
          '</p>' +
          '<img src="" data-url="' +
          imtUrls[i] +
          '" alt="">' +
          '</div>'
        thumImg +=
          '<div class="item-img">' +
          '<img src="" data-index="' +
          i +
          '" data-thumb="' +
          imtUrls[i] +
          '">' +
          '</div>'
      }
      J_items_imgs.html(strImg)
      J_thum_img.html(thumImg)

      that.BoxModel(true, {
        eml: '.wonder',
        eml_act: '#model_wonder',
        off_value: 848,
      })
      $('.slick-sec2').slick({
        infinite: false,
      })
      $('.slick-thumbnail-items').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        touchMove: false,
        swipe: false,
      })
      J_items_imgs.find('.slick-active img')
        .eq(0)
        .attr('src', J_items_imgs.find('.slick-active img').eq(0).data('url'))
      loadImags(J_thum_img)
      $('.slick-sec2').on(
        'beforeChange',
        function (event, slick, currentSlide, nextSlide) {
          J_items_imgs.find('.slick-slide')
            .eq(nextSlide)
            .find('img')
            .attr(
              'src',
              J_items_imgs.find('.slick-slide')
                .eq(nextSlide)
                .find('img')
                .data('url')
            )
        }
      )
      $('.slick-thumbnail-items').on(
        'afterChange',
        function (event, slick, currentSlide, nextSlide) {
          loadImags(J_thum_img)
        }
      )
      that.XClose($('#model_wonder'), 'slick-sec2')
      function loadImags(eml) {
        var _img = eml.find('.slick-active').find('img')
        for (var i = 0; i < _img.length; i++) {
          _img.eq(i).attr('src', _img.eq(i).data('thumb'))
        }
      }
    })

    $(document).on('click', '#J_thum_img .item-img img', (e) => {
      let me = $(e.target)
      let index = me.data('index')
      $('.slick-sec2').slick('slickGoTo', index, true)
    })
  },
  Videos(v) {
    const that = this
    setTitle()
    if (mediaSectionShowLiveTab[v] === '0') {
      $('.r-header button[data-type="live"]').addClass('disabled')
      UpdateItems('video')
      $('#left_header').removeClass('left-header')
    }
    if (mediaSectionShowLiveTab[v] === '1') {
      if (mediaSectionDefaultTab[v] === '1') {
        UpdateItems('video')
        $('.r-header button[data-type="video"]')
          .addClass('active')
          .siblings()
          .removeClass('active')
        $('#left_header').removeClass('left-header')
      } else {
        UpdateItems('live')
        $('.r-header button[data-type="live"]')
          .addClass('active')
          .siblings()
          .removeClass('active')
        $('#left_header').addClass('left-header')
      }
    }
    //video or live
    $('.videos .r-header button').click(function () {
      let me = $(this)
      v = that.getCookie('gameName')
      $('#youku_player').html('')
      if (mediaSectionShowLiveTab[v] === '0') return false

      if (!me.attr('class').includes('active')) {
        if (me.data('type') === 'video') {
          //精彩视频
          UpdateItems('video')
        } else {
          //赛事直播
          UpdateItems('live')
          $('#left_header').addClass('left-header')
        }
        me.addClass('active').siblings().removeClass('active')
      }
    })
    $(document).on('click', '.r-body .video-items li', function (e) {
      let me = $(this)
      videoPlay(me.data('vid'))
      $('.l-header-tit p').html('').html(me.data('title'))
      me.addClass('active').siblings().removeClass('active')
    })
    $(document).on('click', '.l-header .l-header-tit li', function (e) {
      let me = $(this)
      livePlay(me.data('src'))

      $('.l-header .l-header-tit li').removeClass('active')
      me.addClass('active').siblings().removeClass('active')
    })

    function UpdateItems(type) {
      let _url =
        type === 'video'
          ? '/collegeleague2019?task=getvideo&all=1&game=' + v
          : '/collegeleague?task=get_matches&game=' + v
      $.ajax({
        url: _url,
        dataType: 'json',
        success: function (res) {
          let data = res.data
          let strItems = ''
          let strHeader = ''
          if (data.length === 0) {
            $('.l-header-tit').html('')
            $('#youku_player').html('')
            $('#j_' + type + '_items')
              .html('')
              .show()
              .siblings()
              .hide()
            return false
          }
          for (let i = 0; i < data.length; i++) {
            if (type === 'video') {
              strItems +=
                '<li class="' +
                (i == 0 ? 'active' : '') +
                '" data-title="' +
                data[i].title +
                '" data-vid="' +
                data[i].video +
                '">' +
                '<dl>' +
                '<dt><img src="' +
                data[i].thumb +
                '" alt=""></dt>' +
                '<dd>' +
                '<p>' +
                data[i].title +
                '</p>' +
                '<span>' +
                data[i].date +
                '</span>' +
                '</dd>' +
                '</dl>' +
                '</li>'
              if (i === 0) strHeader = '<p>' + data[i].title + '</p>'
            } else if (type === 'live') {
              strItems +=
                '<li data-highlight="' +
                data[i].highlight +
                '">' +
                '<p>' +
                (data[i].date1 === data[i].date2
                  ? data[i].date1 + ' ' + data[i].time1 + ' - ' + data[i].time2
                  : data[i].date1 +
                    ' ' +
                    data[i].time1 +
                    ' - ' +
                    data[i].date2 +
                    ' ' +
                    data[i].time2) +
                '</p>' +
                '<p>' +
                data[i].title +
                '</p>' +
                '</li>'
            }
          }
          if (type === 'video') {
            $('#j_video_items').html('').html(strItems).show().siblings().hide()
            $('.r-body').mCustomScrollbar('destroy')
            $('.r-body').mCustomScrollbar({
              axis: 'y',
              theme: 'light-3',
              autoExpandScrollbar: true,
              advanced: { autoExpandHorizontalScroll: true },
            })
            videoPlay(data[0].video, data[0].thumb)
            $('.l-header-tit').html('').html(strHeader)
            $('#left_header').removeClass('left-header')
          } else {
            $('#j_live_items').html('').html(strItems).show().siblings().hide()
            getLive()
            $('.r-body').mCustomScrollbar('destroy')
            $('.r-body').mCustomScrollbar({
              axis: 'y',
              theme: 'light-3',
              autoExpandScrollbar: true,
              advanced: { autoExpandHorizontalScroll: true },
            })
            $('.r-body').mCustomScrollbar(
              'scrollTo',
              $('#j_live_items li[data-highlight="1"]').index() * 89
            )
            $('#left_header').addClass('left-header')
          }
        },
        error: function (err) {
          console.log(err)
        },
      })
    }
    function videoPlay(vid, thumb) {
      $('#youku_player').html('')

      if (vid && vid.includes('.mp4')) {
        $('#youku_player').html(
          '<video style="width: 100%; height: 100%;" src="' +
            vid +
            '" controls  preload="preload"   autobuffer="true" poster="' +
            thumb +
            '" id="J_main_video"></video>'
        )
      } else {
        var player = new YKU.Player('youku_player', {
          client_id: 'c69ba80d21db5947',
          autoplay: false,
          vid: vid,
        })
      }
    }
    function livePlay(src) {
      let TPL = new Pwrd_Template()
      let liveTemp = $('#J-liveTemp')
      let J_liveTemp = $('#youku_player')
      let isSwf = src.indexOf('swf') > -1
      let temp = TPL.template(liveTemp.html())
      J_liveTemp.html(
        temp({
          data: src,
          isSwf: isSwf,
        })
      )
    }
    function getLive() {
      $.ajax({
        url:
          '/collegeleague?task=get_live_sources&game=' +
          that.getCookie('gameName'),
        dataType: 'json',
        success: function (res) {
          if (!res.success) {
            $('#youku_player').html(
              '<img src="https://img.dota2.com.cn/maps/08/6e/086eb6d2f46ca862ad680fe1c402c8a71551432341.jpg" style="width: 100%;height: 100%;" />'
            )
            return false
          }
          let data = res.data

          let html_str = ''
          if (data.special.length) {
            html_str +=
              '<div class="list-container"><div class="list special-list"><span class="label">特邀解说</span><ul>' +
              renderItem(data.special, 1) +
              '</ul></div>'
          }
          if (data.campus.length) {
            html_str +=
              '<div class="list campus-list"><span class="label">校园解说</span><ul>' +
              renderItem(data.campus, 2) +
              '</ul></div></div>'
          }
          $('.l-header-tit').html(html_str)
          livePlay(data.special[0].video)
        },
        error: function (err) {
          console.log(err)
        },
      })
    }
    function setTitle() {
      $('.l-header h3').html(mediaSectionTitle[v])
    }
    function renderItem(data, type) {
      let strHeader = ''
      for (let i = 0; i < data.length; i++) {
        strHeader +=
          '<li data-src="' +
          data[i].video +
          '" class="' +
          (type === 1 && i === 0 ? 'active' : '') +
          '"><i></i><span>' +
          data[i].title +
          '</span></li>'
      }
      return strHeader
    }
  },
  OnlineTeam(v) {
    const that = this
    let J_search = $('.search')
    let J_search_header = $('.online-team-header')
    J_search.on('focus', 'input', function () {
      $('.search-icon').hide()
    })
    J_search.on('blur', 'input', function () {
      let me = $(this).val()
      if (me === '' || me === null) {
        $('.search-icon').show()
      }
    })
    //搜索
    J_search.find('button').click(() => {
      let search_val = J_search.find('input')
      if (search_val.val()) {
        $.ajax({
          url: '/collegeleague?task=search_online_team&q=' + search_val.val(),
          dataType: 'json',
          success: function (res) {
            let data = res.data
            search_val.val('')
            $('.search-icon').show()
            setSearch(data, 5)
          },
          error: function (err) {
            console.log(err)
          },
        })
      }
    })
    getSearch('', 0)
    initSelect(0)
    //选择游戏
    J_search_header.on('change', '#j_game', function () {
      let me = $(this)
      if (me.val()) {
        initSelect(1)
        getSearch(me.val(), 1)
      } else {
        initSelect(1)
        getSearch('', 0)
      }
    })
    //发布招募
    that.AddRess(v, function () {
      getSearch('', 0)
      initSelect(0)
      $('.btn-recru').html('更新招募信息')
      $('#J_submit').html('更&nbsp;&nbsp;&nbsp;新')
    })
    //查看招募信息
    $(document).on('click', '.online-team-body .tbody li', function () {
      let me = $(this).children('span')

      let item = $('.cat-body .cat-val')
      for (let i = 0; i < item.length; i++) {
        item.eq(i).text(me.eq(i + 1).text())
      }
      that.BoxModel(true, {
        eml: '.btn-recru',
        eml_act: '#j_cat_recruit',
        off_value: 1069,
      })
      that.XClose('#j_cat_recruit')
    })
    function getSearch(v, type) {
      $.ajax({
        url: '/collegeleague?task=get_online_team_grouped&game=' + v,
        dataType: 'json',
        success: function (res) {
          let data = res.data
          setSearch(data, type)
          J_search_header.on('change', '#area', function () {
            let me = $(this)
            if (me.val()) {
              initSelect(2)
              setSearch(data, 2, me.val())
            } else {
              initSelect(2)
            }
          })
          J_search_header.on('change', '#school', function () {
            let me = $(this)
            if (me.val()) {
              setSearch(data, 3, me.val())
            }
          })
          J_search_header.on('change', '#segmen', function () {
            let me = $(this)
            if (me.val()) {
              setSearch(data, 4, me.val())
            }
          })
        },
        error: function (err) {
          console.log(err)
        },
      })
    }
    function setSearch(data, type, chan_val) {
      let opt = '<option value="">--请选择--</option>'
      let opt1 = '<option value="">--请选择--</option>'
      let stritem = []

      $.each(data, function (i, val) {
        if (type === 1 || type === 0) {
          if (type === 1) opt += '<option value="' + i + '">' + i + '</option>'

          $.each(val['tianti_fenduan'], function (q, school) {
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 2 && chan_val == i) {
          $.each(val['college'], function (q, school) {
            if (type === 2 && chan_val === i)
              opt += '<option value="' + q + '">' + q + '</option>'
          })
          $.each(val['tianti_fenduan'], function (a, school) {
            if (type === 2 && chan_val === i)
              opt1 += '<option value="' + a + '">' + a + '</option>'
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 3 && $('#area').val() == i) {
          $.each(val['college'], function (a, school) {
            $.each(school, function (z, segmen) {
              if (chan_val == a) stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 4 && $('#area').val() == i) {
          $.each(val['tianti_fenduan'], function (a, school) {
            $.each(school, function (z, segmen) {
              if (chan_val == a) stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 5) {
          $.each(val, function (q, school) {
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        }
      })
      updateItem(stritem)
      if (type == 1) {
        $('#area').html(opt)
      }
      if (type == 2) {
        $('#school').html(opt)
        $('#segmen').html(opt1)
      }
    }
    function initSelect(index) {
      let selItems = $('.online-team-header select')
      for (let i = index; i < selItems.length; i++) {
        if (i == 0) {
          $('#j_game').html(
            '<option value="" selected="selected">--请选择--</option><option value="dota2">DOTA2</option><option value="csgo">CS:GO</option>'
          )
        } else {
          selItems.eq(i).html('')
        }
      }
    }
    function updateItem(data) {
      data.sort(function (a, b) {
        if (a.update_time < b.update_time) {
          return 1
        }
        if (a.update_time > b.update_time) {
          return -1
        }
        return 0
      })

      let strItem = ''
      for (let i = 0; i < data.length; i++) {
        strItem +=
          '<li>' +
          '<span title="' +
          data[i].nickname +
          '">' +
          data[i].nickname +
          '</span>' +
          '<span>' +
          data[i].game +
          '</span>' +
          '<span title="' +
          data[i].region +
          '">' +
          data[i].region +
          '</span>' +
          '<span title="' +
          data[i].college +
          '">' +
          data[i].college +
          '</span>' +
          '<span>' +
          data[i].tianti_fenduan +
          '</span>' +
          '<span title="' +
          data[i].qq +
          '">' +
          data[i].qq +
          '</span>' +
          '<span title="' +
          data[i].remark +
          '">' +
          data[i].remark +
          '</span>' +
          '<span>' +
          (data[i].status === '1'
            ? "<i class='full'>满</i>"
            : "<i class='trick'>招</i>") +
          '</span>' +
          '<span>' +
          data[i].update_time_str +
          '</span>' +
          '</li>'
      }
      $('.online-team-body .tbody #mCSB_1_container').html('').html(strItem)
      $('.online-team-body .tbody').mCustomScrollbar('update')
    }

    $('.online-team-body .tbody').mCustomScrollbar({
      axis: 'y',
      theme: 'light-3',
      autoExpandScrollbar: true,
      advanced: { autoExpandHorizontalScroll: true },
    })
  },
  Events: function () {
    this.Scrolls()
    this.schoolRecruit()
    this.authProcess()
  },
  schoolRecruit() {
    const that = this
    $('#j_zd li').click(function () {
      let me = $(this)
      let index = me.index()

      if (index == 0) {
        that.BoxModel(true, {
          eml: '#j_zd',
          eml_act: '#model_plan_zy',
          off_value: 955,
        })
        that.XClose('#model_plan_zy')
      } else if (index == 1) {
        window.open('/collegeleague/streamer')
      } else if (index == 3) {
        window.open('/association')
      } else {
        that.BoxModel(true, {
          eml: '#j_zd',
          eml_act: '#model_plan_sx',
          off_value: 816,
        })
        that.XClose('#model_plan_sx')
      }
    })
  },
  EventRules: function (v) {
    var that = this
    var J_events = $('.three-small-btn')

    $('.rules-' + v)
      .show()
      .siblings()
      .hide()

    //登录
    $('.nav-login').click(() => {
      window.location.href = steamCnloginUrl
    })
    //赛事报名
    $('.J_event_entry').click(() => {
      //线下登录
      if (isLogin == '0') {
        window.location.href = steamCnloginUrl
      } else {
        window.location.href = '/collegeleague/apply#entry'
      }
    })

    $('.J_event_entry2').click(() => {
      //线上登录
      window.open(
        that.getCookie('gameName') == 'dota2'
          ? 'https://pvp.wanmei.com/dota2'
          : 'https://pvp.wanmei.com/csgo/home'
      )
    })
    // 赛事查询
    J_events.on('click', '#J_event_info', function () {
      if (isLogin == '0') {
        window.location.href = steamCnloginUrl
      } else {
        window.location.href = '/collegeleague/apply#event_info'
      }
    })
    //赛事规则
    J_events.on('click', '#J_event_rules', function () {
      that.BoxModel(true, {
        eml: '#J_event_rules',
        eml_act: '#J_rules',
        off_value: 1112,
      })

      $('#rule-tit span').html(v == 'dota2' ? 'DOTA2' : 'CS:GO')
      that.XClose($('#J_rules'))
    })

    $('.rules-box').mCustomScrollbar({
      axis: 'y',
      theme: 'light-3',
      autoExpandScrollbar: true,
      advanced: { autoExpandHorizontalScroll: true },
    })
  },
  XClose: function (eml, types) {
    var that = this
    var x = $('.x_close')
    x.click(function () {
      if ($(this).hasClass('closeBtn')) {
        $('#univlist').hide()
        return false
      }
      that.BoxModel(false, {
        eml_act: eml,
      })
      if (types === 'slick-sec2') {
        $('.slick-sec2').slick('unslick')
        $('.slick-thumbnail-items').slick('unslick')
      }
    })
  },
  UpdateNews: function (news_data) {
    for (var i = 0, newstr = ''; i < news_data.length; i++) {
      newstr +=
        '<li>' +
        '<a target="_blank" href="' +
        news_data[i].url +
        '" title="' +
        news_data[i].title +
        '">' +
        '<span>' +
        news_data[i].title +
        '</span>' +
        '<i>' +
        news_data[i].date +
        '</i>' +
        '</a>' +
        '</li>'
    }
    $('#J_news').html(newstr)
  },
  BoxModel: function (bool, options) {
    var that = this
    var option = {
      eml: options.eml || null,
      eml_act: options.eml_act,
      off_value: options.off_value || null,
    }

    $(window).resize(function () {
      Model()
    })

    function Model() {
      that.WIDTH = $(document).width()
      that.HEIGHT = $(document).height()
      let scrollTop = $(window).scrollTop() + 100
      $('.boxModel').css({
        width: that.WIDTH,
        height: that.HEIGHT,
        display: bool ? 'block' : 'none',
      })
      if (bool) {
        $(option.eml_act)
          .css({
            top: scrollTop,
            left: (that.WIDTH - option.off_value) / 2,
          })
          .show()
      } else {
        $(option.eml_act).hide()
      }
    }
    Model()
  },
  Scrolls: function () {
    let that = this
    let J_right_nav = $('.navbar')
    let nav_sign = $('#nav_sign').offset().top - 114
    let nav_reward = $('#nav_reward').offset().top - 114
    let nav_videos = $('#nav_videos').offset().top - 114
    let nav_onteam = $('#nav_onteam').offset().top - 114
    let nav_commentary = $('#nav_commentary').offset().top - 114

    J_right_nav.on('click', 'a', function () {
      nav_sign = $('#nav_sign').offset().top - 114
      nav_reward = $('#nav_reward').offset().top - 114
      nav_videos = $('#nav_videos').offset().top - 114
      nav_onteam = $('#nav_onteam').offset().top - 114
      nav_commentary = $('#nav_commentary').offset().top - 114
      var _index = $(this).attr('class')
      if (_index == 'nav-home') {
        $('html , body').animate({ scrollTop: 0 }, 'show')
      } else if (_index == 'nav-sign') {
        $('html , body').animate({ scrollTop: nav_sign + 180 }, 'show')
      } else if (_index == 'nav-reward2') {
        // 线上赛没有开始
        that.BoxModel(true, {
          eml: '.btn-recru',
          eml_act: '#model_error',
          off_value: 800,
        })
        that.XClose('#model_error')
        $('#error-info').html('').html('敬请期待~')
        // $('html , body').animate({ scrollTop: nav_reward + 100 }, 'show')
      } else if (_index == 'nav-videos') {
        $('html , body').animate({ scrollTop: nav_videos + 100 }, 'show')
      } else if (_index == 'nav-commentary') {
        $('html , body').animate({ scrollTop: nav_commentary + 100 }, 'show')
      } else if (_index == 'nav-onteam') {
        $('html , body').animate({ scrollTop: nav_onteam + 100 }, 'show')
      } else if (_index == 'nav-login') {
        window.location.href = steamCnloginUrl
      }
    })
    $(document).scroll(function () {
      let that = $(this)
      let scrollTop = that.scrollTop()
      if (scrollTop >= nav_sign && scrollTop < nav_reward) {
        $('.nav-sign')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      } else if (scrollTop >= nav_reward && scrollTop < nav_videos) {
        $('.nav-reward')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      } else if (scrollTop >= nav_videos && scrollTop < nav_commentary) {
        $('.nav-videos')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      } else if (scrollTop >= nav_commentary && scrollTop < nav_onteam) {
        $('.nav-commentary')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      } else if (scrollTop >= nav_onteam) {
        $('.nav-onteam')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      } else {
        $('.nav-home')
          .addClass('active')
          .parent('li')
          .siblings('li')
          .children('a')
          .removeClass('active')
      }
    })
    if (this.IsMobile()) {
      J_right_nav.addClass('mavbar-mobile')
    }
  },
  SchoolTitle: function () {
    var J_university_province = $('#university_province')
    var J_university_unis = $('#university_unis')
    for (var i = 0, str = ''; i < schoolData2020.length; i++) {
      str +=
        '<li><a rel="' +
        schoolData2020[i].id +
        '" href="javascript:void(0)" class="' +
        (i == 0 ? 'active' : '') +
        '">' +
        schoolData2020[i].name +
        '</a></li>'
    }
    for (var j = 0, strSchool = ''; j < schoolData2020[0].univs.length; j++) {
      strSchool +=
        '<li><a rel="' +
        schoolData2020[0].univs[j].id +
        '" href="javascript:void(0)">' +
        schoolData2020[0].univs[j].name +
        '</a></li>'
    }
    J_university_province.html('').html(str)
    J_university_unis.html('').html(strSchool)
  },
  AddRess: function (v, callback) {
    let that = this
    let $form = $('#form')
    let fdData = {
      dota2: [
        '先锋',
        '卫士',
        '中军',
        '统帅',
        '传奇',
        '万古流芳',
        '超凡入圣',
        '冠绝一世',
      ],
      csgo: ['白银', '黄金', 'AK（含菊花）', '老鹰', '地球'],
    }
    myOnlineTeamInfos(function (myOnlineTeamInfo) {
      //初始化赛区
      if (myOnlineTeamInfo) {
        setRegion(myOnlineTeamInfo.game, function () {
          releaseRecruit(myOnlineTeamInfo)
        })
      } else {
        setRegion(v, function () {})
      }

      //选择游戏
      $form.on('change', '[name="game"]', function () {
        let me = $(this)
        if (myOnlineTeamInfo) {
          if (me.val()) {
            if (myOnlineTeamInfo['game'] !== me.val()) {
              setRegion(me.val(), function () {})
            } else {
              setRegion(me.val(), function () {
                releaseRecruit(myOnlineTeamInfo)
              })
            }
          }
        } else {
          if (me.val()) {
            setRegion(me.val(), function () {})
          }
        }
      })

      //是否招募
      $('.recruit-footer span').click(function () {
        let me = $(this)
        myOnlineTeamInfos(function (myOnlineTeamInfo) {
          if (me.hasClass('disable')) {
            $.ajax({
              url: '/collegeleague?task=update_online_team_status',
              data: {
                id: myOnlineTeamInfo.id,
                status: '0',
                game: myOnlineTeamInfo.game,
              },
              dataType: 'json',
              success: function (res) {
                me.removeClass('disable')
                getSearch('', 0)
              },
              error: function (err) {
                console.log(err)
              },
            })
          } else {
            $.ajax({
              url: '/collegeleague?task=update_online_team_status',
              data: {
                id: myOnlineTeamInfo.id,
                status: '1',
                game: myOnlineTeamInfo.game,
              },
              dataType: 'json',
              success: function (res) {
                me.addClass('disable')
                getSearch('', 0)
              },
              error: function (err) {
                console.log(err)
              },
            })
          }
        })
      })
    })

    $('.btn-recru').click(() => {
      if (isLogin == '0') {
        window.location.href = steamCnloginUrl
      } else {
        this.BoxModel(true, {
          eml: '.btn-recru',
          eml_act: '#j_recruit',
          off_value: 1069,
        })
        this.XClose('#j_recruit')
      }
    })
    //战队名称
    $form.find('[name="college"]').on('focus', function () {
      that.SchoolTitle()
      var t = $(this)
      that.BoxModel(true, {
        eml: '.btn-recru',
        eml_act: '#univlist',
        off_value: 606,
      })
      that.XClose($('#univlist'))
    })
    //选择学校
    $('#univlist').on('click', '#university_unis a', function () {
      var t = $(this)
      $form
        .find('[name="college"]')
        .val(t.html())
        .removeClass('error')
        .next('.v-message')
        .remove()
      $('#univlist').hide()
    })
    //选择学校省份
    $('#univlist').on('click', '#university_province a', function () {
      var t = $(this)
      var J_university_unis = $('#university_unis')
      var _index = t.attr('rel')
      var _data = schoolData2020[_index - 1].univs
      var province = t.html()
      t.addClass('active')
        .parent('li')
        .siblings('li')
        .children('a')
        .removeClass('active')
      for (var i = 0, str = ''; i < _data.length; i++) {
        str +=
          '<li><a rel="' +
          _data[i].id +
          '" href="javascript:void(0)">' +
          _data[i].name +
          '</a></li>'
      }
      J_university_unis.html('').html(str)
    })
    //提交表单
    $('#J_submit').click(() => {
      if (!that.isOpen) return false
      that.isOpen = false
      that.VerifyFormat()
      if ($form.find('.error').length === 0) {
        that.options.remark = $form.find('[name="remark"]').val()

        myOnlineTeamInfos(function (myOnlineTeamInfo) {
          if (!myOnlineTeamInfo) {
            that.options.id = 0
          } else {
            that.options.id = myOnlineTeamInfo.id
          }
        })

        $.ajax({
          url: '/collegeleague?task=save_online_team',
          data: that.options,
          dataType: 'json',
          success: function (res) {
            let data = res
            if (data.success) {
              that.BoxModel(false, {
                eml_act: '#j_recruit',
              })
              setTimeout(() => {
                that.BoxModel(true, {
                  eml: '.btn-recru',
                  eml_act: '#model_error',
                  off_value: 800,
                })
                that.XClose('#model_error')
                $('#error-info').html('').html(data.msg)
                that.isOpen = true
              }, 500)
              callback()
              myOnlineTeamInfos(function (myOnlineTeamInfo) {
                if (myOnlineTeamInfo) {
                  setRegion(myOnlineTeamInfo.game, function () {
                    releaseRecruit(myOnlineTeamInfo)
                  })
                } else {
                  setRegion(v, function () {})
                }
              })
            } else {
              that.BoxModel(false, {
                eml_act: '#j_recruit',
              })
              setTimeout(() => {
                that.BoxModel(true, {
                  eml: '.btn-recru',
                  eml_act: '#model_error',
                  off_value: 800,
                })
                that.XClose('#model_error')
                $('#error-info').html('').html(data.msg)
                that.isOpen = true
              }, 500)
            }
          },
          error: function (error) {
            console.log(error)
          },
        })
      } else {
        that.isOpen = true
      }
    })

    function setRegion(v, callback) {
      let opts1 = '<option value="">--请选择--</option>'
      if (online) {
        let region_data = {
          dota2: [
            '上海',
            '江苏',
            '浙江',
            '山东',
            '广东',
            '湖北',
            '湖南',
            '四川',
            '北京',
            '陕西',
            '重庆',
            '河南',
            '天津',
            '河北',
            '辽宁',
            '黑龙江',
            '云南',
            '江西',
            '安徽',
            '福建',
            '山西',
            '甘肃',
            '吉林',
            '贵州',
            '西藏',
            '青海',
            '宁夏',
            '新疆',
            '内蒙古',
            '广西',
            '海南',
            '港澳台',
          ],
          csgo: [
            '上海',
            '江苏',
            '浙江',
            '山东',
            '广东',
            '湖北',
            '湖南',
            '四川',
            '陕西',
            '重庆',
            '北京',
            '河南',
            '天津',
            '内蒙古',
            '河北',
            '辽宁',
            '黑龙江',
            '广西',
            '江西',
            '安徽',
            '贵州',
            '甘肃',
            '西藏',
            '青海',
            '宁夏',
            '新疆',
            '云南',
            '海南',
            '吉林',
            '福建',
            '山西',
            '港澳台',
          ],
        }

        let opts = '<option value="">--请选择--</option>'
        for (let i = 0; i < region_data[v].length; i++) {
          opts +=
            '<option value="' +
            region_data[v][i] +
            '">' +
            region_data[v][i] +
            '</option>'
        }
        $form.find('[name="region"]').html('').html(opts)
        // 线上赛
      } else {
        //线下赛
        $.ajax({
          url: '/collegeleague2019/matches?game=' + v,
          dataType: 'json',
          success: function (res) {
            let data = res.data
            let opts = '<option value="">--请选择--</option>'
            for (let i = 0; i < data.length; i++) {
              opts +=
                '<option value="' +
                data[i].city +
                '">' +
                data[i].city +
                '</option>'
            }
            $form.find('[name="region"]').html('').html(opts)
            //是否发布招募
            callback()
          },
          error: function (err) {
            console.log(err)
          },
        })
      }

      for (let i = 0; i < fdData[v].length; i++) {
        opts1 +=
          '<option value="' + fdData[v][i] + '">' + fdData[v][i] + '</option>'
      }
      $form.find('[name="tianti_fenduan"]').html('').html(opts1)

      if (online) {
        //是否发布招募
        callback()
      }
    }

    function releaseRecruit(myOnlineTeamInfo) {
      $('#J_submit').html('更&nbsp;&nbsp;&nbsp;新')
      // $form.find('[name="nickname"]').val(myOnlineTeamInfo.nickname);
      $form
        .find('[name="region"] option[value="' + myOnlineTeamInfo.region + '"]')
        .prop('selected', true)
      $form
        .find('[name="game"] option[value="' + myOnlineTeamInfo.game + '"]')
        .prop('selected', true)
      $form.find('[name="college"]').val(myOnlineTeamInfo.college)
      $form
        .find(
          '[name="tianti_fenduan"] option[value="' +
            myOnlineTeamInfo.tianti_fenduan +
            '"]'
        )
        .prop('selected', true)
      $form.find('[name="qq"]').val(myOnlineTeamInfo.qq)
      // $form.find('[name="phone"]').val( myOnlineTeamInfo.phone);
      $form.find('[name="remark"]').val(myOnlineTeamInfo.remark)

      if (myOnlineTeamInfo.status === '1') {
        $('.recruit-footer span').addClass('disable')
      }
      $('.recruit-footer span').show()
      $('.recruit-footer p').show()

      $('.btn-recru').html('更新招募信息')
    }
    function myOnlineTeamInfos(callback) {
      $.ajax({
        url: '/collegeleague?task=get_my_online_team',
        dataType: 'json',
        success: function (res) {
          let data = res.data
          callback(data)
        },
        error: function (err) {
          console.log(err)
        },
      })
    }
    function getSearch(v, type) {
      $.ajax({
        url: '/collegeleague?task=get_online_team_grouped&game=' + v,
        dataType: 'json',
        success: function (res) {
          let data = res.data
          setSearch(data, 0)
        },
        error: function (err) {
          console.log(err)
        },
      })
    }
    function setSearch(data, type, chan_val) {
      let opt = '<option value="">--请选择--</option>'
      let opt1 = '<option value="">--请选择--</option>'
      let stritem = []

      $.each(data, function (i, val) {
        if (type === 1 || type === 0) {
          if (type === 1) opt += '<option value="' + i + '">' + i + '</option>'

          $.each(val['tianti_fenduan'], function (q, school) {
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 2 && chan_val == i) {
          $.each(val['college'], function (q, school) {
            if (type === 2 && chan_val === i)
              opt += '<option value="' + q + '">' + q + '</option>'
          })
          $.each(val['tianti_fenduan'], function (a, school) {
            if (type === 2 && chan_val === i)
              opt1 += '<option value="' + a + '">' + a + '</option>'
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 3 && $('#area').val() == i) {
          $.each(val['college'], function (a, school) {
            $.each(school, function (z, segmen) {
              if (chan_val == a) stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 4 && $('#area').val() == i) {
          $.each(val['tianti_fenduan'], function (a, school) {
            $.each(school, function (z, segmen) {
              if (chan_val == a) stritem = stritem.concat(segmen)
            })
          })
        } else if (type === 5) {
          $.each(val, function (q, school) {
            $.each(school, function (a, segmen) {
              stritem = stritem.concat(segmen)
            })
          })
        }
      })
      updateItem(stritem)
    }
    function updateItem(data) {
      data.sort(function (a, b) {
        if (a.update_time < b.update_time) {
          return 1
        }
        if (a.update_time > b.update_time) {
          return -1
        }
        return 0
      })

      let strItem = ''
      for (let i = 0; i < data.length; i++) {
        strItem +=
          '<li>' +
          '<span title="' +
          data[i].nickname +
          '">' +
          data[i].nickname +
          '</span>' +
          '<span>' +
          data[i].game +
          '</span>' +
          '<span title="' +
          data[i].region +
          '">' +
          data[i].region +
          '</span>' +
          '<span title="' +
          data[i].college +
          '">' +
          data[i].college +
          '</span>' +
          '<span>' +
          data[i].tianti_fenduan +
          '</span>' +
          '<span title="' +
          data[i].qq +
          '">' +
          data[i].qq +
          '</span>' +
          '<span title="' +
          data[i].remark +
          '">' +
          data[i].remark +
          '</span>' +
          '<span>' +
          (data[i].status === '1'
            ? "<i class='full'>满</i>"
            : "<i class='trick'>招</i>") +
          '</span>' +
          '<span>' +
          data[i].update_time_str +
          '</span>' +
          '</li>'
      }
      $('.online-team-body .tbody #mCSB_1_container').html('').html(strItem)
      $('.online-team-body .tbody').mCustomScrollbar('update')
    }
  },
  VerifyFormat() {
    var that = this
    var $form = $('#form')
    var $required = $form.find('[required]')

    if ($form.find('[name="remark"]').val().length > 200) {
      $form.find('[name="remark"]').addClass('error')
    }

    //智能清除提示
    $form.find('[name="remark"]').on('input propertychange', function () {
      if ($form.find('[name="remark"]').val().length > 200) {
        $form.find('[name="remark"]').addClass('error')
      } else {
        $form.find('[name="remark"]').removeClass('error')
      }
    })
    $required.on('input propertychange', function () {
      $(this).removeClass('error').next('.v-message').remove()
    })

    //判断是否为空
    $required.each(function () {
      if (that.isEmpty(this.value) && !$(this).hasClass('error')) {
        $(this).addClass('error')
      }
      that.options[$(this).attr('name')] = this.value
    })
  },
  IsMobile: function () {
    var userAgentInfo = navigator.userAgent
    var Agents = new Array(
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
      'Windows CE',
      'BlackBerry'
    )
    var flag = false
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = true
        break
      }
    }
    return flag
  },
  isPhone(str) {
    return /^1\d{10}$/.test(str)
  },
  isEmpty(str) {
    return '' == str.replace(/^\s+|\s+$/, '')
  },
  setCookie: function (name, value, time) {
    var exp = new Date()
    exp.setTime(exp.getTime() + time * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value)
    // + ";expires=" + exp.toGMTString();
  },
  getCookie: function (cname) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
    }
    return ''
  },
  wxshare: function (v) {
    //wx share
    wx.ready(function () {
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: shareTitle,
        desc: shareInfo,
        link: window.location.href,
        imgUrl: shareUrl,
        trigger: function (res) {
          // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
          //alert('用户点击发送给朋友');
        },
        success: function (res) {
          //
        },
        cancel: function (res) {
          //alert('已取消');
        },
        fail: function (res) {
          alert(JSON.stringify(res))
        },
      })
      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareTitle,
        link: window.location.href,
        imgUrl: shareUrl,
        trigger: function (res) {
          // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
          //alert('用户点击分享到朋友圈');
        },
        success: function (res) {
          //
        },
        cancel: function (res) {
          //alert('已取消');
        },
        fail: function (res) {
          alert(JSON.stringify(res))
        },
      })
      //分享到QQ
      wx.onMenuShareQQ({
        title: shareTitle, // 分享标题
        desc: shareInfo, // 分享描述
        link: location.href, // 分享链接
        imgUrl: shareUrl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      })
    })
  },
}

$(function () {
  index.Init()

  $('.lrw-item').click(function (e) {
    window.open('https://esports.wanmei.com/solo')
  })

  let $commentarySchool = $('#commentarySchool')

  if ($commentarySchool.children().size() == 2) {
    $commentarySchool.children().eq(0).css({
      transform: 'translateX(-80px)',
    })
    $commentarySchool.children().eq(1).css({
      transform: 'translateX(80px)',
    })
  }

  if ($commentarySchool.children().size() == 4) {
    $commentarySchool.children().eq(3).css({
      marginRight: 0,
    })
  }
  if ($commentarySchool.children().size() > 4) {
    $commentarySchool.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      autoplaySpeed: 2000,
    })
  }

  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop()
    if (scrollTop >= $('.time-line').offset().top) {
      $('#sidebar').css({ left: 0 })
    } else {
      $('#sidebar').css({ left: '-185px' })
    }
  })

  $('#closeSideBar').click(function () {
    $(this).parent().css({ left: '-169px' }).delay(300).fadeOut(100)
  })

  let setCookie = function (name, value, expire) {
    let exdate = new Date()
    exdate.setTime(exdate.getTime() + expire * 60 * 1000)
    document.cookie =
      name +
      '=' +
      value +
      (expire == null ? ';path=/' : ';expires=' + exdate.toUTCString()) +
      ';path=/'
  }

  $('.j_close_dialog').click(function () {
    setCookie('collegeleague2020_dialog', 1, 60)
    $(this).parents('.m-dialog').hide()
  })
})
